import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from 'techlify-ng';

const routes: Routes = [
];
import { OrganizationViewAllComponent } from "./organization-view-all.component";
routes.push({ path: 'organizations', component: OrganizationViewAllComponent, canActivate: [AuthGuard] });

export const OrganizationRoutingProvider = RouterModule.forRoot(routes, { useHash: true });